import { createContext } from 'react';

export const LocalStorageContext = createContext(null);
